import React from 'react';
import styles from './StoryboardSpinner.module.scss';
import { CustomButton } from '../../../../components/Button/Button';
import { useTranslation } from 'react-i18next';

const StoryboardSpinner = ({ text, textStyle, subtext, subtextStyle, onCancel }) => {

  const { t } = useTranslation();

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.loaderBackground} />
            <div className={styles.figuresContainer}>
              <div className={styles.square} />
              <div className={styles.round} />
              <div className={styles.rectangle} />
            </div>
          </div>
          {text && (
            <h2 className={styles.loadingText} style={textStyle}>
              {text}
            </h2>
          )}
          {subtext && (
            <p className={styles.loadingSubtext} style={subtextStyle}>
              {subtext}
            </p>
          )}
          {onCancel && <CustomButton label={t('general.cancel')} variant='secondary' onClick={onCancel} />}
        </div>
      </div>
    </div>
  );
};

export default StoryboardSpinner;
